module.exports = "https://www.ilove11.top/img/face8.7e38a61a.gif";